import * as Yup from 'yup';
import TextField from '@mui/material/TextField';
import { PlatformVersionField } from './types';

export const getPlatformVersionFormFields = (isEdit?: boolean) => [
  {
    name: PlatformVersionField.EdgeComponentName,
    label: 'Edge component name',
    placeholder: 'Enter the edge component name',
    Component: TextField,
    validation: Yup.string().required('Edge component name is required'),
    disabled: isEdit,
    required: true,
  },
  {
    name: PlatformVersionField.DockerImage,
    label: 'Docker image',
    placeholder: 'Enter the docker image',
    Component: TextField,
    validation: Yup.string().required('Docker image is required'),
    required: true,
  },
  {
    name: PlatformVersionField.Version,
    label: 'Version',
    placeholder: 'Enter the version',
    Component: TextField,
    validation: Yup.string().required('Version is required'),
    required: true,
  },
];
